export var AdbFeatures;
(function (AdbFeatures) {
    AdbFeatures["StatV2"] = "stat_v2";
    AdbFeatures["Cmd"] = "cmd";
    AdbFeatures["ShellV2"] = "shell_v2";
})(AdbFeatures = AdbFeatures || (AdbFeatures = {}));
//# sourceMappingURL=features.js.map